require('./insurancesRequestWizardStep2SliderLabel.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const className = require('classnames');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const { EURO_SYMBOL } = require('constants/index');

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

const InsurancesRequestWizardStep2SliderLabel = (
    {
        labelName,
        tooltipCont,
        continentIcon,
        showLabelDetails,
        continentValue,
        minMaxValues
    }) => {
    const tooltipLabel = <OKTooltip content={tooltipCont} offset={[0, -15]} />;
    const iconClass = className('insurance-request-wizard-step-two-label__icons-slider', {
        'icon-continente': continentIcon,
        'icon-contenido': !continentIcon,
    });
    const continentMinValue = formatAmount(minMaxValues.MIN, undefined, 0);
    const continentMaxValue = formatAmount(minMaxValues.MAX, undefined, 0);
    const formatMinValue = `${formatText('insuranceRequestHome-step2Min', [continentMinValue])} ${EURO_SYMBOL}`;
    const formatMaxValue = `${formatText('insuranceRequestHome-step2Max', [continentMaxValue])} ${EURO_SYMBOL}`;
    const labelMinMaxValues = showLabelDetails &&
        <div className="insurance-request-wizard-step-two-label--text-top insurance-request-wizard-step-two-label__values">
            ({formatMinValue} / {formatMaxValue})
        </div>
    const labelMaxValue = showLabelDetails &&
        <div className="insurance-request-wizard-step-two-label--text-top insurance-request-wizard-step-two-label__continent-value">
            {`${continentValue} ${EURO_SYMBOL}`}
        </div>
    return (
        <div className="insurance-request-wizard-step-two-label">
            <i className={iconClass}></i>
            <label className="insurance-request-wizard-step-two-label--text-top insurance-request-wizard-step-two-label__label-name">
                <FormattedText value={labelName} />
                {tooltipLabel}
            </label>
            {labelMinMaxValues}
            {labelMaxValue}
        </div>
    )
}

InsurancesRequestWizardStep2SliderLabel.propTypes = {
    labelName: PropTypes.string.isRequired,
    isPostAppraisal: PropTypes.bool.isRequired,
    tooltipCont: PropTypes.string.isRequired,
    continentIcon: PropTypes.bool.isRequired,
    showLabelDetails: PropTypes.bool.isRequired,
    continentValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    minMaxValues: PropTypes.object.isRequired,
}

InsurancesRequestWizardStep2SliderLabel.defaultProps = {
    labelName: '',
    isPostAppraisal: false,
    tooltipCont: '',
    continentIcon: false,
    showLabelDetails: false,
    labelValues: [],
    continentValue: 0,
    minMaxValues: {},
}

module.exports = InsurancesRequestWizardStep2SliderLabel;
